// The site's page spacing and title standard (WHIT-469, Claude Design option
// A′ on the ticket). Kept in components/ so Tailwind scans these class names.

// A page title (with H1 gopher): 32px on a 40px line on phones,
// 40px on a 48px line from lg.
const PAGE_TITLE = 'max-lg:text-[2rem] max-lg:leading-10 lg:leading-[3rem]';

// Space between the navbar and a page's title: 32px phone, 48px desktop.
const PAGE_TOP = 'pt-8 lg:pt-12';

// Space above the footer, and the padding of the home page sections:
// 56px phone, 80px desktop.
const SECTION_Y = 'py-14 lg:py-20';
const PAGE_BOTTOM = 'pb-14 lg:pb-20';

// The reading column of the text pages: 672px, centred.
const TEXT_COLUMN = 'mx-auto max-w-2xl';

// Gap between cards in a grid.
const CARD_GAP = 'gap-6';

// Space between a fixed tab bar (results, cart) and the content below it:
// the card gap, so the first card sits in the page's rhythm (WHIT-471/472).
const FIXED_BAR_GAP = 'pt-6';

// Space between the sections of a form page, e.g. the cart's passenger,
// billing, discount, consent and payment sections: 48px (WHIT-472).
const SECTION_GAP = 'mt-12';

module.exports = {
  PAGE_TITLE,
  PAGE_TOP,
  SECTION_Y,
  PAGE_BOTTOM,
  TEXT_COLUMN,
  CARD_GAP,
  FIXED_BAR_GAP,
  SECTION_GAP,
};
